export default "__VITE_ASSET__Cy87Lv91__"